import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Auditor } from "@app/Domain/Models/auditor.model";
import { environment } from "environments/environments";
import { BaseService } from "./base.service";
import { SessionStorageService } from "./session-storage.service";

@Injectable({
    providedIn: "root"
})
export class AuditorService extends BaseService {
    private url = environment.BaseUrl + "Auditor";
    private putUrl = this.url + "EditEntity/";

    private http = inject(HttpClient);
    private sessionStorage = inject(SessionStorageService);

    get auditor(): Auditor {
        return this.sessionStorage.get("auditor");
    }

    getAllAuditores(): Observable<Auditor[]> {
        return this.http.get<Auditor[]>(this.url, this.getHeader(this.auditor.idiomaAuditorInterface));
    }

    getAllAuditoresByAuditRegion(idAuditRegion: number): Observable<Auditor[]> {
        return this.http.get<Auditor[]>(
            `${this.url}/auditRegion/${idAuditRegion}`,
            this.getHeader(this.auditor.idiomaAuditorInterface)
        );
    }

    getById(id: number): Observable<Auditor> {
        return this.http.get<Auditor>(`${this.url}/${id}`, this.getHeader(this.auditor.idiomaAuditorInterface));
    }

    getAuditorbyAuditRegion(id: number): Observable<Auditor[]> {
        return this.http.get<Auditor[]>(
            this.url + "/GetAuditorByAuditRegion/" + id,
            this.getHeader(this.auditor.idiomaAuditorInterface)
        );
    }

    create(formData: FormData): Observable<any> {
        return this.http.post(`${this.url}`, formData, this.GetHeaderToFile(this.auditor.idiomaAuditorInterface));
    }

    update(formData: FormData, id: number): Observable<any> {
        return this.http.put(`${this.url}/${id}`, formData, this.GetHeaderToFile(this.auditor.idiomaAuditorInterface));
    }

    updateStatus(id: number, newStatus: boolean): Observable<boolean> {
        return this.http.patch<boolean>(
            `${this.url}/changeStatus/${id}`,
            { active: newStatus },
            this.getHeader(this.auditor.idiomaAuditorInterface)
        );
    }

    updateEmail(id: number, newEmail: string): Observable<any> {
        return this.http.patch(
            `${this.url}/changeEmail/${id}`,
            { newEmail: newEmail },
            this.getHeader(this.auditor.idiomaAuditorInterface)
        );
    }

    //Update Work Entity on Auditor
    updateWorkYear(codAuditor: number, year: number): Observable<any> {
        const url = `${this.putUrl}${codAuditor}`;

        const updatedWorkYear = {
            cod_Auditor: codAuditor,
            anoTrabalho: year
        };

        return this.http.put(
            this.url + "/EditWorkYear/" + codAuditor,
            JSON.stringify(updatedWorkYear),
            this.getHeader(this.auditor.idiomaAuditorInterface)
        );
    }

    isAdm(): boolean {
        return this.auditor?.descPerfil === "Administração";
    }

    isCoordenador() {
        return this.auditor?.descPerfil === "Coordenador_Audit";
    }

    formData(formValue: any, signatureFile?: File): FormData {
        const formData = new FormData();

        if (formValue.codAuditor) {
            formData.append("codAuditor", formValue.codAuditor.toString());
        }

        formData.append("nomeAuditor", String(formValue.nomeAuditor));
        formData.append("nomeAuditorAbreviado", String(formValue.nomeAuditorAbreviado));
        formData.append("ativo", formValue.ativo.toString());
        formData.append("emailAuditor", String(formValue.emailAuditor));
        formData.append("calendarColor", formValue.calendarColor ? String(formValue.calendarColor) : "");
        formData.append("idTipoPlanoAuditoria", formValue.idTipoPlanoAuditoria.toString());
        formData.append("idPais", formValue.idPais.toString());
        formData.append("idiomaAuditor", String(formValue.idiomaAuditor));
        formData.append("idiomaAuditorInterface", String(formValue.idiomaAuditorInterface));
        formData.append("idRegiaoAuditoria", formValue.idRegiaoAuditoria.toString());
        formData.append("idPerfil", formValue.idPerfil.toString());
        formData.append("dataValidadePerfil", String(formValue.dataValidadePerfil));
        formData.append("areaAtuacao", formValue.areaAtuacao ?? "");
        formData.append("crcAuditor", formValue.crcAuditor ?? "");
        formData.append("assinaturaAuditor", formValue.assinaturaAuditor ?? "");
        formData.append("usuarioCorporativo", formValue.usuarioCorporativo.toString());
        formData.append("smtpServidor", formValue.smtpServidor ?? "");
        formData.append("smtpPorta", formValue.smtpPorta ? String(formValue.smtpPorta) : "");
        formData.append("smtpUsuario", formValue.smtpUsuario ?? "");
        formData.append("smtpSenha", formValue.smtpSenha ?? "");
        formData.append("smtpSsl", formValue.smtpSsl.toString());
        formData.append("smtpTls", formValue.smtpTls.toString());
        formData.append("smtpCertificado", formValue.smtpCertificado.toString());

        if (signatureFile) {
            formData.append("auditorSignature", signatureFile, signatureFile.name);
        }

        return formData;
    }
}
